import React from 'react';
import { Link } from 'react-router-dom';

// const dotsLarge = [
//   { id: 1, top: '45%', left: '10%', label: 'Sweatshirt', link: 'https://www.veshheon.in/collections/SweatShirt' },
//   { id: 2, top: '45%', left: '20%', label: 'Hoodie', link: 'https://www.veshheon.in/collections/Hoodie' },
//   { id: 3, top: '45%', left: '30%', label: 'Oversized Hoodie', link: 'https://www.veshheon.in/collections/OverSized%20Hoodie' },
//   { id: 4, top: '45%', left: '50%', label: 'Varsity Jacket', link: 'https://www.veshheon.in/collections/Varsity%20Jacket' },
//   { id: 5, top: '45%', left: '70%', label: 'Acid Washed Hoodie', link: 'https://www.veshheon.in/collections/Acid%20Washed%20Hoodie' },
//   { id: 6, top: '45%', left: '80%', label: 'Zip Hoodie', link: 'https://www.veshheon.in/collections/Zip%20Hoodie' },
//   { id: 7, top: '45%', left: '90%', label: 'Oversized Sweatshirt', link: 'https://www.veshheon.in/collections/OverSized%20SweatShirt' },
// ];

// const dotsSmall = [
//   { id: 1, top: '25%', left: '15%', label: 'Sweatshirt', link: 'https://www.veshheon.in/collections/SweatShirt' },
//   { id: 2, top: '42%', left: '20%', label: 'Hoodie', link: 'https://www.veshheon.in/collections/Hoodie' },
//   { id: 3, top: '55%', left: '30%', label: 'Oversized Hoodie', link: 'https://www.veshheon.in/collections/OverSized%20Hoodie' },
//   { id: 4, top: '65%', left: '50%', label: 'Varsity Jacket', link: 'https://www.veshheon.in/collections/Varsity%20Jacket' },
//   { id: 5, top: '55%', left: '70%', label: 'Acid Washed Hoodie', link: 'https://www.veshheon.in/collections/Acid%20Washed%20Hoodie' },
//   { id: 6, top: '42%', left: '78%', label: 'Zip Hoodie', link: 'https://www.veshheon.in/collections/Zip%20Hoodie' },
//   { id: 7, top: '25%', left: '85%', label: 'Oversized Sweatshirt', link: 'https://www.veshheon.in/collections/OverSized%20SweatShirt' },
// ];

// const PulseDot = ({ top, left, link, label }) => (
//   <a
//     href={link}
//     target="_self"
//     className="absolute group"
//     style={{ top, left }}
//   >
//     <span className="relative flex h-4 w-4">
//       <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
//       <span className="relative inline-flex rounded-full h-4 w-4 bg-white"></span>
//     </span>

//     {/* Tooltip (Desktop only) */}
//     <span className="hidden md:block absolute left-1/2 -translate-x-1/2 mt-3 whitespace-nowrap rounded bg-black px-3 py-1 text-xs text-white opacity-0 transition group-hover:opacity-100">
//       {label}
//     </span>
//   </a>
// );

const Hero = () => {
  return (
    <section className="relative w-full overflow-hidden">

      {/* Mobile Image */}
      <div className="relative md:hidden">
        <img
          src="https://res.cloudinary.com/dukimifv5/image/upload/f_webp/q_auto:good/hero_1_qfok5k"
          alt="Winter Collection"
          className="w-full h-auto"
        />
        {/* {dotsSmall.map(dot => (
          <PulseDot key={dot.id} {...dot} />
        ))}  */}
      </div>

      {/* Desktop Image */}
      <div className="relative hidden md:flex h-screen max-h-[100vh] items-center justify-center">
        <img
          src="https://res.cloudinary.com/dukimifv5/image/upload/f_webp/q_auto:good/hero_1_qfok5k"
          alt="Winter Collection"
          className="w-full h-full object-cover"
        />
        {/* {dotsLarge.map(dot => (
          <PulseDot key={dot.id} {...dot} />
        ))} */}
      </div>

    </section>
  );
};

export default Hero;
